import React from 'react';
import './ModuleLoadingStatus.css';
import Spinner from '../Spinner/Spinner';
import logComponent from '../../common/logComponent';

export default function ModuleLoadingStatus({ isLoading, isError, reloadAction, margin, align }) {
  if (logComponent('ModuleLoadingStatus')) { console.debug('ModuleLoadingStatus render'); }

  let style = {};

  if (margin) { style.margin = `${margin} 0`; }
  if (align) { style.alignItems = align; }

  return (
    <React.Fragment>
      {
        (isLoading || isError) &&
        <div className="Module-Loading-Status" style={style}>
          {
            isLoading ?
              <div className="Module-Loading-Status__spinner" >
                <Spinner size="3rem" />
              </div> :
              isError &&
              <div className="Module-Loading-Status__error" >
                <p className="Module-Loading-Status__error-message">Sorry, we couldn't load that data.</p>
                <button
                  className="Module-Loading-Status__reload-button"
                  onClick={reloadAction}>Try again</button>
              </div>
          }
        </div>
      }
    </React.Fragment>
  );
}
